<template>
  <div class="contract_market">
    <p class="market">{{ $t('永续合约') }}</p>
    <div class="search_box">
      <input
        :value="searchContract"
        :placeholder="$t('搜索')"
        @input="handleSearch"
      />
      <SvgIcon name="shousuo" slot="prefix"></SvgIcon>
    </div>
    <div class="tabpane_box">
      <div class="sort_box">
        <div
          class="left_sort"
          @click="
            handleClickSort({ type: 'SET_CONTROL_COIN', field: 'controlCoin' })
          "
        >
          <span>{{ $t('币种') }}</span>
          <img
            style="width: 10px; height: 14px"
            :src="
              controlCoin === 0
                ? noneActive
                : controlCoin === 1
                ? upActive
                : downActive
            "
            alt=""
          />
        </div>
        <div
          class="middle_sort"
          @click="
            handleClickSort({
              type: 'SET_CONTROL_PRICE',
              field: 'controlPrice',
            })
          "
        >
          <span>
            {{ $t('最新价') }}
          </span>
          <img
            style="width: 10px; height: 14px"
            :src="
              controlPrice === 0
                ? noneActive
                : controlPrice === 1
                ? upActive
                : downActive
            "
            alt=""
          />
        </div>
        <div
          class="right_sort"
          @click="
            handleClickSort({
              type: 'SET_CONTROL_UPDOWN',
              field: 'controlUpDown',
            })
          "
        >
          <span>{{ $t('涨幅') }}</span>
          <img
            style="width: 10px; height: 14px"
            :src="
              controlUpDown === 0
                ? noneActive
                : controlUpDown === 1
                ? upActive
                : downActive
            "
            alt=""
          />
        </div>
      </div>

      <div
        v-loading="!this.quotes.length"
        :element-loading-background="
          currentSkin === 'black'
            ? 'rgba(23, 27, 43, 1)'
            : 'rgba(255, 255, 255, 1)'
        "
        class="contract_box"
      >
        <ul v-if="quotes.length" class="coin_ul">
          <li
            v-for="(item, index) in displayedQuotes"
            :key="index"
            :class="{
              active_coin_li: item.contractNo === contractData.contractNo,
            }"
            class="each_coin_li"
            @click="handleContract(item)"
          >
            <div class="coin_type">
              <span> {{ item.coin }}</span>
            </div>
            <span class="new_price">
              {{ item.price }}
            </span>
            <span
              :class="{
                up_green: Number(item.change) > 0,
                down_red: Number(item.change) < 0,
              }"
              class="up_down_num"
            >
              {{ item.change }}%
            </span>
          </li>
        </ul>
        <NoData
          v-else
          :sceneType="currentSkin === 'black' ? 'night' : 'day'"
        ></NoData>
      </div>
    </div>
  </div>
</template>
<script>
import { sendWSPush, createSocket } from '@/utils/contractWebSocket'
import { mapState, mapGetters } from 'vuex'
import sortMixin from '@/mixin/sort'

export default {
  mixins: [sortMixin],
  data() {
    return {
      searchContract: '',
      noneActive: require('@/assets/images/qiehuan1.png'),
      downActive: require('@/assets/images/qiehuan2.png'),
      upActive: require('@/assets/images/qiehuan3.png'),
    }
  },
  async created() {
    createSocket(process.env.VUE_APP_CONTRACT_WS)
    if (!this.quotes.length) {
      sendWSPush({ channel: 'public', language: 'zh' })
    }
  },
  computed: {
    ...mapGetters(['isSignIn']),
    ...mapState({
      controlCoin: (state) => state.contract.controlCoin,
      controlPrice: (state) => state.contract.controlPrice,
      controlUpDown: (state) => state.contract.controlUpDown,
      currentSkin: (state) => state.contract.currentSkin,
      quotes: (state) => state.contract.quotes,
      contractData: (state) => state.contract.contractData,
    }),
    displayedQuotes() {
      let _quotes = [...this.quotes]
      if (this.searchContract) {
        _quotes = _quotes.filter((item) =>
          item.coin.includes(this.searchContract.toUpperCase())
        )
      }

      if (this.controlUpDown) {
        this.sortContractList(_quotes, this.controlUpDown === 1, 'change')
      }
      if (this.controlPrice) {
        this.sortContractList(_quotes, this.controlPrice === 1, 'price')
      }
      if (this.controlCoin) {
        this.sortContractList(_quotes, this.controlCoin === 1, 'coin')
      }
      return _quotes
    },
  },
  methods: {
    compareStrings(str1, str2) {
      const minLength = Math.min(str1.length, str2.length)
      for (let i = 0; i < minLength; i++) {
        if (str1[i] < str2[i]) {
          return false
        } else if (str1[i] > str2[i]) {
          return true
        }
      }

      return str1.length - str2.length > 0
    },
    sortContractList(arr, isAscending, field) {
      arr.sort((cur, next) => {
        const ret =
          field === 'coin'
            ? this.compareStrings(cur[field], next[field])
              ? 1
              : -1
            : cur[field] - next[field]
        return isAscending ? ret : -ret
      })
    },
    // 处理点击排序
    handleClickSort(sortObj) {
      ;['SET_CONTROL_COIN', 'SET_CONTROL_PRICE', 'SET_CONTROL_UPDOWN'].forEach(
        (item) => {
          if (!sortObj) {
            this.$store.commit(`contract/${item}`, 0)
          } else {
            const { type, field } = sortObj
            if (type === item) {
              let val = this[field]
              val = val < 2 ? ++val : 0
              this.$store.commit(`contract/${item}`, val)
            } else {
              this.$store.commit(`contract/${item}`, 0)
            }
          }
        }
      )
    },
    // 搜索合约
    handleSearch(val) {
      this.searchContract = val
      this.handleClickSort()
    },

    // 点击列表中某一个币种
    handleContract(item) {
      this.$store.commit('contract/SET_CONTRACT_DATA', item)
    },
  },
}
</script>
<style lang="less" scoped>
.contract_market {
  width: 320px;
  height: 100%;
  background: @contentBgColor1;
  .market {
    padding: 20px 0 0 20px;
    font-size: 26px;
    line-height: 30px;
    font-family: PingFangSC-Medium, 'PingFang SC';
    font-weight: 500;
    color: @textColor1;
  }
  .search_box {
    position: relative;
    margin: 20px 0px;
    padding: 0 20px;
    input {
      width: 100%;
      height: 100%;
      padding-left: 34px;
      outline: none;
      font-size: 16px;
      color: var(--textColor2, #616888);
      line-height: 22px;
      height: 32px;
      border: 1px solid #383f66;
      background-color: transparent;
      border-radius: 8px;
      &::placeholder {
        color: #c5c8ce;
      }
    }
    svg {
      position: absolute;
      left: 30px;
      top: 50%;
      transform: translateY(-50%);
      width: 14px;
      height: 14px;
    }
  }
  .tabpane_box {
    height: calc(100% - 122px);
    position: relative;
    .sort_box {
      padding: 6px 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      position: relative;
      .left_sort,
      .middle_sort,
      .right_sort {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        span {
          margin-right: 2px;
          font-size: 12px;
          font-weight: 400;
          color: @textColor2;
          line-height: 18px;
        }
      }
      .middle_sort {
        position: absolute;
        right: 105px;
      }
    }
    .contract_box {
      margin-top: 4px;
      overflow-y: auto;
      height: calc(100% - 34px);
      .coin_ul {
        .each_coin_li {
          // 布局要点
          padding: 5px 20px;
          display: flex;
          flex-direction: row;
          cursor: pointer;
          .coin_type {
            width: 85px;
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-shrink: 0;
          }
          .new_price {
            display: inline-block;
            width: 106px;
            text-align: right;
            flex-shrink: 0;
          }
          .up_down_num {
            display: inline-block;
            width: 86px;
            text-align: right;
            flex-shrink: 0;
          }
          span {
            font-size: 14px;
            font-weight: 400;
            color: @textColor3;
            line-height: 20px;
          }
          // 动态改变字体颜色
          .up_green {
            color: rgba(65, 179, 126, 1);
          }
          .down_red {
            color: rgba(223, 52, 61, 1);
          }
        }
        // 每个币种鼠标移入背景颜色
        .each_coin_li:hover {
          background-color: @hoverBgColor;
        }
        // 当前币种高亮背景颜色
        .active_coin_li {
          background: @hoverBgColor;
        }
      }
    }
  }
}
</style>
